export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/bnpl/HomeView.vue'),
  },
  {
    meta: { title: 'menu.userCredit' },
    path: '/user-credit',
    name: 'user-credit',
    component: async () => await import('@/views/bnpl/UserCredit.vue'),
  },
  {
    meta: { title: 'menu.generatePasskeys' },
    path: '/generate-passkeys',
    name: 'generate-passkeys',
    component: async () => await import('@/views/bnpl/GeneratePasskey.vue'),
  }
]
